<!-- Mobile backdrop -->
@if (mobileOpen()) {
  <div class="fixed inset-0 bg-black/40 z-[35] md:hidden" (click)="closeMobile()"></div>
}

<!-- Mobile hamburger button -->
<button
  (click)="toggleMobile()"
  class="fixed top-4 z-50 md:hidden p-2 rounded-lg bg-white border border-stone-200 shadow-sm transition-[left] duration-300"
  [style.left]="mobileOpen() ? 'calc(16rem + 0.75rem)' : '0.75rem'"
  [attr.aria-expanded]="mobileOpen()"
  aria-label="Menu"
  title="Menu"
>
  <svg class="w-5 h-5 text-stone-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
    @if (mobileOpen()) {
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
    } @else {
      <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
    }
  </svg>
</button>

<aside
  class="fixed left-0 top-0 bottom-0 min-h-dvh h-screen transition-all duration-300 z-40 flex flex-col"
  style="background-color: #1f2937;"
  [class.w-64]="isOpen()"
  [class.w-20]="!isOpen()"
  [class.sidebar-mobile-open]="mobileOpen()"
>
  <!-- Sidebar Header -->
  <div style="padding: 12px; height: 4.5rem; border-bottom: 1px solid #374151;" class="flex items-center">
    @if (isOpen()) {
      <div class="w-full flex items-center justify-center">
        <img src="assets/images/sportiq-logo-v2.png" alt="SportIQ" style="height: 3rem;" class="object-contain" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'" />
        <div style="display:none;" class="items-center gap-2">
          <div class="w-8 h-8 rounded-lg bg-primary-600 flex items-center justify-center">
            <span class="material-icons text-white text-sm">sports</span>
          </div>
          <span class="text-white font-semibold text-sm">SportIQ</span>
        </div>
      </div>
    }
  </div>

  <!-- Toggle Button -->
  <button
    (click)="toggleSidebar()"
    class="absolute top-20 -right-5 p-2 rounded-lg transition-all z-50 hidden md:block"
    style="border: 3px solid #fafbf6; background-color: #111827; color: #fafbf6;"
    title="Afficher / masquer le menu"
  >
    <svg class="w-4 h-4 transition-transform" stroke="#fafbf6" [style.transform]="!isOpen() ? 'scaleX(-1)' : 'scaleX(1)'" fill="none" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
    </svg>
  </button>

  <!-- Menu Items (expanded) -->
  @if (isOpen()) {
    <nav class="flex-1 px-3 py-6 space-y-2 overflow-y-auto">
      <div class="space-y-1">
        <p class="px-4 mb-2 text-xs font-semibold uppercase tracking-widest text-stone-500">Gestion</p>
        @for (item of menuItems(); track item.key) {
          @if (!item.children || item.children.length === 0) {
            <!-- Leaf item -->
            <button
              (click)="navigateTo(item)"
              class="nav-item w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200"
              [class.nav-active]="isActive(item.route)"
              [title]="item.label"
            >
              <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg"
                [style.background-color]="isActive(item.route) ? '#5998e5' : 'transparent'">
                <span class="material-icons text-sm" [style.color]="isActive(item.route) ? '#fff' : '#5998e5'">{{ item.icon }}</span>
              </span>
              <span class="text-sm font-medium truncate"
                [class.text-stone-300]="!isActive(item.route)"
                [class.text-white]="isActive(item.route)">{{ item.label }}</span>
            </button>
          } @else {
            <!-- Parent item — always open, no toggle -->
            <div>
              <div class="w-full flex items-center gap-3 px-4 py-3 rounded-lg">
                <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg"
                  [style.background-color]="isParentActive(item) ? '#5998e5' : 'transparent'">
                  <span class="material-icons text-sm" [style.color]="isParentActive(item) ? '#fff' : '#5998e5'">{{ item.icon }}</span>
                </span>
                <span class="text-sm font-medium truncate"
                  [class.text-stone-300]="!isParentActive(item)"
                  [class.text-white]="isParentActive(item)">{{ item.label }}</span>
              </div>

              <div class="ml-4 mt-1 space-y-0.5 border-l border-stone-600 pl-3">
                @for (child of item.children; track child.key) {
                  @if (child.isGroup) {
                    <!-- Collapsible sub-group header -->
                    <button
                      (click)="toggleGroup(child.key)"
                      class="w-full flex items-center gap-2 px-3 py-1.5 rounded-lg transition-all duration-200 text-xs font-semibold uppercase tracking-wider text-stone-400 hover:text-stone-200"
                      [title]="child.label"
                    >
                      <svg class="w-3 h-3 flex-shrink-0 transition-transform duration-200"
                        [style.transform]="isGroupExpanded(child.key) ? 'rotate(90deg)' : 'rotate(0deg)'"
                        fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                      </svg>
                      <span class="truncate">{{ child.label }}</span>
                    </button>
                    @if (isGroupExpanded(child.key)) {
                      <div class="ml-3 pl-2 border-l border-stone-700 space-y-0.5 mb-1">
                        @for (page of child.children; track page.key) {
                          <button
                            (click)="navigateTo(page)"
                            class="nav-item w-full flex items-center gap-2 px-3 py-1.5 rounded-lg transition-all duration-200 text-sm"
                            [class.nav-active]="isChildActive(page)"
                            [class.text-stone-400]="!isChildActive(page)"
                            [class.text-white]="isChildActive(page)"
                            [title]="page.label"
                          >
                            <span class="flex-shrink-0 w-1.5 h-1.5 rounded-full"
                              [style.background-color]="isChildActive(page) ? '#5998e5' : '#4b5563'">
                            </span>
                            <span class="truncate">{{ page.label }}</span>
                          </button>
                        }
                      </div>
                    }
                  } @else {
                    <!-- Leaf child -->
                    <button
                      (click)="navigateTo(child)"
                      class="nav-item w-full flex items-center gap-3 px-3 py-2 rounded-lg transition-all duration-200 text-sm"
                      [class.nav-active]="isChildActive(child)"
                      [class.text-stone-400]="!isChildActive(child)"
                      [class.text-white]="isChildActive(child)"
                      [title]="child.label"
                    >
                      <span class="flex-shrink-0 w-4 h-4 flex items-center justify-center text-xs">
                        <span class="material-icons" style="font-size: 16px;"
                          [style.color]="isChildActive(child) ? '#fff' : '#9ca3af'">{{ child.icon }}</span>
                      </span>
                      <span class="truncate">{{ child.label }}</span>
                    </button>
                  }
                }
              </div>
            </div>
          }
        }
      </div>
    </nav>

    <!-- Footer -->
    <div style="border-top: 1px solid #374151;" class="px-3 py-4">
      <div class="px-4 py-2 text-center">
        <p class="text-xs text-stone-500">SportIQ Marketing v1.0</p>
      </div>
    </div>
  }

  <!-- Collapsed: Icons only -->
  @if (!isOpen()) {
    <nav class="flex-1 px-2 py-6 space-y-3 overflow-y-auto">
      @for (item of menuItems(); track item.key) {
        <button
          (click)="item.children?.length ? navigateToParent(item) : navigateTo(item)"
          class="nav-item w-full flex items-center justify-center p-3 rounded-lg transition-all duration-200"
          [class.nav-active]="isActive(item.route) || isParentActive(item)"
          [title]="item.label"
        >
          <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg"
            [style.background-color]="isActive(item.route) || isParentActive(item) ? '#5998e5' : 'transparent'">
            <span class="material-icons text-sm"
              [style.color]="isActive(item.route) || isParentActive(item) ? '#fff' : '#5998e5'">{{ item.icon }}</span>
          </span>
        </button>
      }
    </nav>
  }
</aside>

<!-- Spacer (desktop) -->
<div
  class="transition-all duration-300 hidden md:block flex-shrink-0"
  [class.md:w-64]="isOpen()"
  [class.md:w-20]="!isOpen()"
  style="background-color: #1f2937;"
></div>
